import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceListEvidenceFieldSectionsPathParameters } from 'api/actions/device-list-evidence-field-sections/device-list-evidence-field-sections-path-parameters';
import { DeviceListEvidenceFieldSectionsResponse } from 'api/actions/device-list-evidence-field-sections/device-list-evidence-field-sections-response';

type DeviceListEvidenceFieldSectionsQueryParameters = Record<string, any>;

/**
 * The path of the DeviceListEvidenceFieldSections action.
 */
export const deviceListEvidenceFieldSectionsActionPath = new SweetPath<
  keyof DeviceListEvidenceFieldSectionsPathParameters
>('/api/device/evidence-field-sections', { path: '{param}' });

/**
 * Creates a contextualized DeviceListEvidenceFieldSections actions.
 */
export default function createDeviceListEvidenceFieldSectionsAction(axios: AxiosInstance) {
  return function deviceListEvidenceFieldSectionsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: DeviceListEvidenceFieldSectionsQueryParameters } = {}) {
    const path = deviceListEvidenceFieldSectionsActionPath.original;

    return axios.request<DeviceListEvidenceFieldSectionsResponse, DeviceListEvidenceFieldSectionsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
